import { render, staticRenderFns } from "./comm-from-search.vue?vue&type=template&id=4ff23b16&scoped=true&"
import script from "./comm-from-search.vue?vue&type=script&lang=js&"
export * from "./comm-from-search.vue?vue&type=script&lang=js&"
import style0 from "./comm-from-search.vue?vue&type=style&index=0&id=4ff23b16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff23b16",
  null
  
)

export default component.exports